import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import NumbersRoundedIcon from '@mui/icons-material/NumbersRounded';
import { useCallback } from 'react';
import { MenuItemContainer } from '../../../components/menuItemContainer';
export const PlayerCopyIdAdminMenuItem = ({ playerIdName, closeMenu }) => {
    const onClick = useCallback(() => {
        navigator.clipboard.writeText(`${playerIdName.id}`);
    }, [playerIdName.id]);
    return (_jsx(MenuItemContainer, { label: `Copy ID ${playerIdName.id}`, svgIconComponent: NumbersRoundedIcon, onClick: onClick, closeMenu: closeMenu }));
};
